import { StyledBox } from './Box.styles';

export default StyledBox;
